var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 22 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_690_6235)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62683 5.67375L6.30758 0.561035V0.561861H8.12268L5.42546 8.07878H3.61036L2.07129 1.60994C3.15864 2.23791 4.13296 3.50211 4.44373 4.66548L4.62683 5.67375ZM8.8143 0.561035L7.74103 8.08629H9.45652L10.5291 0.561035H8.8143ZM13.9889 3.6264C13.3894 3.29285 13.0219 3.06772 13.0219 2.72656C13.0292 2.41638 13.3326 2.09859 14.0103 2.09859C14.5676 2.08282 14.9773 2.2304 15.288 2.37723L15.4437 2.45552L15.6769 0.88105C15.3381 0.733471 14.8008 0.570863 14.1372 0.570863C12.4431 0.570863 11.2502 1.56328 11.2428 2.98266C11.2288 4.03008 12.0969 4.61131 12.7465 4.95998C13.4101 5.31765 13.636 5.54955 13.636 5.86733C13.6287 6.35524 13.0994 6.58037 12.6055 6.58037C11.9212 6.58037 11.5537 6.46442 10.9957 6.19255L10.7698 6.0766L10.5299 7.71285C10.9329 7.91468 11.6739 8.09232 12.4432 8.10141C14.2436 8.10141 15.415 7.12402 15.4298 5.61132C15.4356 4.78151 14.9779 4.14594 13.9889 3.6264ZM18.7477 0.584324H20.0749L21.4582 8.09232H19.8703L19.6131 6.59317H17.5988L17.103 8.08629H15.3026L17.8508 1.18975C18.0279 0.716872 18.3387 0.584324 18.7477 0.584324ZM18.0983 5.08633C18.1349 5.08254 18.7892 2.64893 18.7892 2.64893L19.3118 5.08633H18.0983Z",
    fill: "#220BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.95321 1.53155C3.81966 0.957749 3.39373 0.570758 2.81525 0.5625H0.101072L0.0731201 0.701737C2.19037 1.27851 3.96749 3.05325 4.54402 4.72261L3.95321 1.53155Z",
    fill: "#FD8500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_690_6235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.4024,
    height: 7.59777,
    fill: "white",
    transform: "translate(0.0731201 0.541992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.64512611c511fca5b2ebc1aec8f2f498.svg";
export { ForwardRef as ReactComponent };